module.exports = {
  identityPoolId: process.env.COGNITO_FEDERATED_ID,
  region: process.env.COGNITO_REGION,
  userPoolId: process.env.COGNITO_USERPOOL_ID,
  userPoolWebClientId: process.env.COGNITO_CLIENT_ID,
  oauth: {
    domain: process.env.COGNITO_AUTH_DOMAIN,
    // these urls need to match the - App integration / App client settings
    // in cognito, for this user pool, to work. If any changes are made, the
    // Google/FB etc. developer portals may need to be updated as well.
    // https://console.cloud.google.com/apis/credentials
    redirectSignIn: process.env.COGNITO_AUTH_SIGNIN,
    redirectSignOut: process.env.COGNITO_AUTH_SIGNOUT,
    scope: ['profile', 'openid', 'email', 'aws.cognito.signin.user.admin'],
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOL',
};



// WEBPACK FOOTER //
// ./src/mixins/aws/amplify.js